var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M21.5 22.313c0 .345-.247.63-.568.68l-.099.007h-17c-.693 0-1.262-.545-1.327-1.243l-.006-.132V1.687c0-.345.247-.63.568-.68L3.167 1H4.5c.335 0 .612.254.66.586l.007.101V20.25h15.666c.335 0 .612.254.66.586l.007.102v1.375zm-4.333-9.363c0 .275-.267.55-.534.55H8.367c-.267 0-.534-.275-.534-.55V11.3c0-.275.267-.55.534-.55h8.266c.267 0 .534.275.534.55v1.65zm-5.334 4.125c0 .275-.266.55-.533.55H8.367c-.267 0-.534-.275-.534-.55v-1.65c0-.275.267-.55.534-.55H11.3c.267 0 .533.275.533.55v1.65zM18.5 4.7c0 .275-.267.55-.533.55h-9.6c-.267 0-.534-.275-.534-.55V3.05c0-.275.267-.55.534-.55h9.6c.266 0 .533.275.533.55V4.7zm-4 4.125c0 .275-.267.55-.533.55h-5.6c-.267 0-.534-.275-.534-.55v-1.65c0-.275.267-.55.534-.55h5.6c.266 0 .533.275.533.55v1.65z"
  }))));
}

export default SvgChartBar;